// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post_title__E7eCv {
  font-weight: 700;
  font-size: 3rem;
}

.post_post-title__tFh\\+P, .post_post-content__WDDwb {
  font-size: 1.6rem;
}
.post_post-title__tFh\\+P:focus, .post_post-content__WDDwb:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important;
  border-color: #6c757d;
}

.post_image-file__zKQo\\+ {
  font-size: 1.3rem;
}
.post_image-file__zKQo\\+:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important;
  border-color: #6c757d;
}

.post_post-title__tFh\\+P {
  font-weight: 600;
}

.post_tit__Krb1A {
  font-size: 1.8rem;
  font-weight: 600;
}

.post_categories__FbZ6\\+ {
  font-size: 1.4rem;
}
.post_categories__FbZ6\\+:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important;
  border-color: #6c757d;
}

.post_success__rHsNJ {
  font-size: 1.4rem;
}

.post_new-post__IOpFz {
  font-size: 1.6rem;
  border-radius: 8px;
}
.post_new-post__IOpFz:hover {
  color: #6c757d;
  background-color: transparent;
}

.post_jodit-ui-group__Cmx3n {
  display: none !important;
}

.post_quill__Pjyxx p {
  font-size: 1.8rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/post/post.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;AACI;EACI,aAAA;EACA,4DAAA;EACA,qBAAA;AACR;;AAEA;EACI,iBAAA;AACJ;AAEI;EACI,aAAA;EACA,4DAAA;EACA,qBAAA;AAAR;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,iBAAA;EACA,gBAAA;AADJ;;AAGA;EACI,iBAAA;AAAJ;AAEI;EACI,aAAA;EACA,4DAAA;EACA,qBAAA;AAAR;;AAGA;EACI,iBAAA;AAAJ;;AAEA;EACI,iBAAA;EACA,kBAAA;AACJ;AACI;EACI,cAAA;EACA,6BAAA;AACR;;AAEA;EACI,wBAAA;AACJ;;AAEE;EACE,iBAAA;AACJ","sourcesContent":[".title{\n    font-weight: 700;\n    font-size: 3rem;\n    // padding: 50px 0;\n}\n.post-title,.post-content{\n    font-size: 1.6rem;\n\n    &:focus{\n        outline: none;\n        box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important; \n        border-color: #6c757d;\n  }\n}\n.image-file{\n    font-size: 1.3rem;\n    \n\n    &:focus{\n        outline: none;\n        box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important; \n        border-color: #6c757d;\n  }\n\n}\n.post-title{\n    font-weight: 600;\n}\n\n.tit{\n    font-size: 1.8rem;\n    font-weight: 600;\n}\n.categories{\n    font-size: 1.4rem;\n\n    &:focus{\n        outline: none;\n        box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important; \n        border-color: #6c757d;\n  }\n}\n.success{\n    font-size: 1.4rem;\n}\n.new-post{\n    font-size: 1.6rem;\n    border-radius: 8px;\n\n    &:hover{\n        color: #6c757d;\n        background-color: transparent;\n    }\n}\n.jodit-ui-group {\n    display: none !important;\n  }\n\n  .quill p{\n    font-size: 1.8rem;\n  }\n  \n  \n  \n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `post_title__E7eCv`,
	"post-title": `post_post-title__tFh+P`,
	"post-content": `post_post-content__WDDwb`,
	"image-file": `post_image-file__zKQo+`,
	"tit": `post_tit__Krb1A`,
	"categories": `post_categories__FbZ6+`,
	"success": `post_success__rHsNJ`,
	"new-post": `post_new-post__IOpFz`,
	"jodit-ui-group": `post_jodit-ui-group__Cmx3n`,
	"quill": `post_quill__Pjyxx`
};
export default ___CSS_LOADER_EXPORT___;
